import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.5rem;
  max-width: 1500px;
  margin: 0 auto;
  min-height: calc(100vh - 64px);
`;

export const Title = styled.h1`
  font-size: 2.1rem;
  color: #2d3748;
  margin-bottom: 2rem;
  font-weight: 600;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const Section = styled.section`
  width: 100%;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  overflow: hidden;
  transition: all 0.2s ease;
  
  &:hover {
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  z-index: 10000;
`;

export const ModalCard = styled.div`
  width: min(920px, 100%);
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 0.75rem;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.25);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  padding: 1rem 1.25rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #0f172a;
`;

export const ModalBody = styled.div`
  padding: 1.25rem;
`;

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.9rem 1rem;

  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
`;

export const Label = styled.label`
  font-size: 0.9rem;
  font-weight: 700;
  color: #334155;
`;

export const Input = styled.input`
  height: 40px;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  padding: 0 0.75rem;
  font-size: 1rem;
  color: #0f172a;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #cbd5e1;
    box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.25);
  }
`;

export const Select = styled.select`
  height: 40px;
  border-radius: 0.5rem;
  border: 1px solid #e2e8f0;
  padding: 0 0.75rem;
  font-size: 1rem;
  color: #0f172a;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus {
    border-color: #cbd5e1;
    box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.25);
  }
`;

export const CheckboxRow = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  font-size: 0.9rem;
  color: #0f172a;
  font-weight: 600;
  user-select: none;
`;

export const Checkbox = styled.input`
  width: 16px;
  height: 16px;
`;

export const ModalActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  margin-top: 1.25rem;
  padding-top: 1rem;
  border-top: 1px solid #e2e8f0;
`;

export const CardHeader = styled.div`
  padding: 1.1rem 1.75rem;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  color: #2d3748;
  font-size: 1.2rem;
  
  svg {
    color: #4a5568;
  }
`;

export const HeaderLeft = styled.div`
  display: inline-flex;
  align-items: center;
`;

export const HeaderActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`;

export const SelectedInfo = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (max-width: 640px) {
    width: 100%;
    justify-content: flex-start;
  }
`;

export const SelectedPill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.6rem;
  border-radius: 9999px;
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #334155;
  font-size: 0.85rem;
  font-weight: 700;

  span {
    font-weight: 600;
    color: #64748b;
  }
`;

export const ActionButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  padding: 0.55rem 0.95rem;
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #2d3748;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #f8fafc;
    border-color: #cbd5e0;
  }

  svg {
    color: inherit;
  }
`;

export const IconButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 0.375rem;
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #ef4444;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #fee2e2;
    border-color: #fecaca;
  }

  svg {
    color: inherit;
  }
`;

export const CardBody = styled.div`
  padding: 1.75rem;
  overflow-x: auto;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 1rem;

  th, td {
    padding: 0.95rem 1.25rem;
    text-align: left;
    border-bottom: 1px solid #e2e8f0;
  }

  th {
    background-color: #f8fafc;
    color: #4a5568;
    font-weight: 600;
    text-transform: uppercase;
    font-size: 0.8rem;
    letter-spacing: 0.05em;
  }

  tr:last-child td {
    border-bottom: none;
  }

  tr:hover td {
    background-color: #f8fafc;
  }
`;

export const VerMaisButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 1rem;
  padding: 0.7rem 1rem;
  background: transparent;
  border: 1px solid #e2e8f0;
  color: #4a5568;
  border-radius: 0.375rem;
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
  
  &:hover {
    background: #f8fafc;
    border-color: #cbd5e0;
  }
  
  svg {
    margin-left: 0.5rem;
    transition: transform 0.2s ease;
  }
`;
